import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "open-container",
  id: "openContainerBackground"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-filter" }, null, -1)
const _hoisted_3 = { class: "open-container-textbox" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-logo" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-location revealDiv" }, "Gold's Gym Tbilisi", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "open-container-title revealDiv" }, [
  /*#__PURE__*/_createTextVNode("Discover The"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Legacy")
], -1)
const _hoisted_7 = { class: "open-container-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "default-button-container membership-button",
          to: "/buy"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Become A Member")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}